// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__-X6mX","title":"Menu_title__kWhUw"};